<template>
    <component :is="layout" v-if="!loadingApp">
        <router-view />
    </component>
    <b-block-loader v-else :color="loaderColor">
        <!-- <template #default>
            <b-svg name="b-loader" />
        </template> -->
    </b-block-loader>
</template>

<script>
import { ref, defineAsyncComponent, computed, watch, onMounted, nextTick, provide } from 'vue';
import { app } from '@beautybox/ui-kit/plugins/app';
import useProfileStore from '@/stores/profile';
import { useRoute, useRouter } from 'vue-router';
import useDarkTheme from '@beautybox/ui-kit/composables/useDarkTheme';
const MainLayout = defineAsyncComponent(() => import('@/layouts/MainLayout.vue'));
const BBlockLoader = defineAsyncComponent(() =>
    import('@beautybox/ui-kit/components/blocks/BlockLoader/index.vue')
);
const BSvg = defineAsyncComponent(() =>
    import('@beautybox/ui-kit/components/icons/BSvg/index.vue')
);

export default {
    components: {
        MainLayout,
        BBlockLoader,
        BSvg,
    },
    mixins: [app],

    setup() {
        const route = useRoute();
        const router = useRouter();
        const { getUserInfo } = useProfileStore();
        const { isDark } = useDarkTheme();
        const loadingApp = ref(true);

        const loadGlobalData = async () => {
            loadingApp.value = true;
            await getUserInfo();
            loadingApp.value = false;
        };

        const loaderColor = computed(() => {
            return isDark.value ? 'white' : 'primary';
        });

        onMounted(() => {
            if (router.currentRoute.value.name) {
                loadGlobalData();
            }
        });

        const stopWatch = watch(
            () => router.currentRoute.value,
            (value) => {
                if (value.name) {
                    loadGlobalData();
                    stopWatch();
                }
            }
        );

        provide('isDark', isDark.value);

        return { isDark, loadingApp, loadGlobalData, loaderColor };
    },
};
</script>
